import React from "react";
import { X } from "lucide-react";

/**
 * ─── Tag ──────────────────────────────────────────────────────────────────
 * Neutral non-status chip for plan / country / currency / feature names.
 * Distinct from StatusBadge (which carries state semantics).
 *
 * Props
 *   tone      "neutral" | "accent" | "info" | "success" | "warning" | "danger"
 *   outline   boolean       — outline-only variant
 *   onClose   fn            — renders an X to remove
 *   testId
 */
export default function Tag({ tone = "neutral", outline = false, onClose, children, testId }) {
  const cn = [
    "ds-tag",
    tone !== "neutral" && `ds-tag--${tone}`,
    outline && "ds-tag--outline",
  ].filter(Boolean).join(" ");
  return (
    <span className={cn} data-testid={testId}>
      {children}
      {onClose && (
        <button type="button" onClick={onClose} className="ds-tag__close"
                aria-label="Remove tag">
          <X size={10} strokeWidth={2.4} />
        </button>
      )}
    </span>
  );
}
